import { scrollbar } from 'src/theme/mixins';
import { Frame } from '../UI';
import { styled } from '@mui/material/styles';

export const FormFrame = styled(Frame, {
	target: 'FormFrame-root',
	label: 'FormFrame',
})({
	'& .chat__main': {
		paddingLeft: 0,
		paddingRight: 0,
		paddingTop: 0,
		display: 'flex',
		flex: 1,
		'& .form__inputs': {
			flex: 1,
			padding: '2em 2em 0',
			...scrollbar({ visible: true, direction: 'vertical' }),
		},
		'& .form__submit': {
			paddingLeft: '2em',
			paddingRight: '2em',
			paddingTop: '1.5em',
			paddingBottom: '1.5em',
		},
	},
});
